import type {CancellablePromise} from '@yourcoach/async-utils';

import {CancelRequestError} from '../../../utils/errors/app';

export const makeCancelable = (
  promise: Promise<any>,
  abortController?: AbortController,
): CancellablePromise<any> => {
  let isCanceled = false;

  const wrappedPromise = new Promise<any>((resolve, reject) => {
    promise
      .then(val =>
        isCanceled ? reject(new CancelRequestError()) : resolve(val),
      )
      .catch(error =>
        isCanceled ? reject(new CancelRequestError()) : reject(error),
      );
  });

  // @ts-expect-error: TODO: describy why
  wrappedPromise.cancel = () => {
    isCanceled = true;

    if (abortController) {
      abortController.abort();
    }
  };

  return wrappedPromise as CancellablePromise<any>;
};
